import React from "react";

function TradeField({tradeArr, by}){
	let passedValues = [];
	if(by === "Import"){
		passedValues = tradeArr.tradeImportArr;
	} else if(by === "Export"){
		passedValues = tradeArr.tradeExportArr;
	} else if(by === "ImportQty"){
		passedValues = tradeArr.topImportQtyArr;
	} else if(by === "ImportVal"){
		passedValues = tradeArr.topImportValArr;
	} else if(by === "ExportQty"){
		passedValues = tradeArr.topExportQtyArr;
	} else if(by === "ExportVal"){
		passedValues = tradeArr.topExportValArr;
	}
	return(
		passedValues.map( (passedValue) =>(
			( (by === "Import" ) || (by === "Export") )?
			<tr>
				<td>{passedValue["partner"]}</td>  
				<td>{passedValue["value_1000_usd_"]}</td>
			</tr>
			:
			( (by === "ImportQty") || (by === "ExportQty") )?
			<tr>
				<td>{passedValue["commodity"]}</td>
				<td>{passedValue["quantity_tons_"]}</td>
			</tr>
			: 
			( (by === "ImportVal") || (by === "ExportVal") )?
			<tr>
				<td>{passedValue["commodity"]}</td> 
				<td>{passedValue["value_1000_usd_"]}</td>
			</tr>
			: ""
		))
	)
}

export default TradeField;